import { observer } from 'mobx-react';
import queryString from 'querystring';
import { useLocation } from 'react-router-dom';

import { themeStore } from 'Models/ThemeStore';
import { TabSelected } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardTypes';
import { BookingWizardWrap } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardWrap';
import BookingWizardBackground from 'Views/Components/_HumanWritten/BookingWizardBG/BookingWizardBackground';
import NavigationWrapper from 'Views/Components/Navigation/NavigationWrapper';
import SecuredPage from 'Views/Components/Security/SecuredPage';

function BookingWizardPage() {
	const location = useLocation();
	const queryParams = location.search.substring(1);
	const params = queryString.parse(queryParams);

	return (
		<SecuredPage>
			<NavigationWrapper />
			<div className="booking-wizard-nav-spacer" />
			<div className="body-content">
				<BookingWizardBackground src={themeStore.bookingWizardBackgroundImageURL} />
				<BookingWizardWrap queryParams={queryParams === '' ? undefined : params} />
			</div>
		</SecuredPage>
	);
}

export interface BookingWizardPageParams {
	date?: Date;
	fromLocation?: string;
	toLocation?: string;
	routeId?: string;
	type: TabSelected;
	ferryTripId?: string;
	fromLocationName?: string;
	toLocationName?: string;
	bookingId?: string;

	// Feature: Multi-stop - wizard params
	// All three should be populated, otherwise, it shouldn't be used
	departureTripId?: string;
	startStopId?: string;
	endStopId?: string;

	departingTripId?: string;
	departingStartStopId?: string;
	departingEndStopId?: string;

	returningTripId?: string;
	returningStartStopId?: string;
	returningEndStopId?: string;

	mode?: 'create' | 'alteration' | 'bulk';
}

export default observer(BookingWizardPage);
